<template>
    <div v-if="consultations.length" class="w-consultations widget">
        <div class="w-consultations__body">
            <span class="w-consultations__name widget__name">Recent consultations</span>
            <div class="w-consultations__content">
                <div class="w-consultations__list v-list">
                    <consultation :consultation="consultation" v-for="consultation in consultations" :key="consultation.id"></consultation>
                </div>
            </div>
        </div>
        <div class="w-consultations__footer">
            <a href="/account/consultations" class="w-consultations__button r-link button button_secondary">See all consultations</a>
            <a href="/vets" class="w-consultations__button r-link button">Start a new consultation</a>
        </div>
    </div>
</template>

<script>
    import Consultation from "./Consultation";
    import api from "../../../../admin/api/api";

    export default {
        name: 'RecentConsultations',
        components: {
            Consultation
        },
        data(){
            return {
                consultations: []
            }
        },
        mounted() {
            this.getConsultations();
        },
        methods: {
            getConsultations() {
                api.get('/api/widget/consultations/recent').then(response => {
                   this.consultations = response.data;
                });
            }
        }
    }
</script>

